export const GET_GENERAL_CONCEPTS         = 'GET_GENERAL_CONCEPTS';
export const CHANGE_INPUT_VALUE_GENERAL   = 'CHANGE_INPUT_VALUE_GENERAL';
export const SAVE_GENERAL_CONCEPT         = 'SAVE_GENERAL_CONCEPT';
export const GET_INFO_GENERAL_CONCEPT     = 'GET_INFO_GENERAL_CONCEPT';
export const DELETE_GENERAL_CONCEPT       = 'DELETE_GENERAL_CONCEPT';
export const GENERAL_CONCEPT_DEFAULT_DATA = 'GENERAL_CONCEPT_DEFAULT_DATA';